export const SET_ENTIDADE = 'setEntidade';
export const SET_ENTIDADE_FROM_ID = 'setEntidadeFromId';
export const SET_ENTIDADES = 'setEntidades';
export const INITIALIZE_FROM_COOKIES = 'initFromCookies';
export const SET_LOADING = 'setLoading';
